import CryptoJS from "crypto-js";

export const objectToQueryString = (obj: any, prefix = ""): string => {
    const params = [];
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            const paramKey = prefix
                ? `${prefix}[${encodeURIComponent(key)}]`
                : encodeURIComponent(key);
            if (value instanceof Array) {
                value.forEach((item, index) => {
                    if (typeof item === "object") {
                        params.push(objectToQueryString(item, `${paramKey}[${index}]`));
                    } else {
                        params.push(`${paramKey}[${index}]=${encodeURIComponent(item)}`);
                    }
                });
            } else if (typeof value === "object") {
                params.push(objectToQueryString(value, paramKey));
            } else {
                params.push(`${paramKey}=${encodeURIComponent(value)}`);
            }
        }
    }
    return params.join("&");
};


export const convertObjectToQueryString = (obj: any) => {
    const queryString = Object.keys(obj)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join("&");
    return queryString;
};

// Encrypting text
export const encryptText = (token: string) => {
    token = token.toString();
    // Convertong token to cipher text
    const ciphertext = CryptoJS.AES.encrypt(
        token,
        process.env.REACT_APP_PUBLIC_ENCRYPTION_SECRET as string // Assuming env var is defined
    ).toString();
    return ciphertext;
};

// Decrypting text
export const decryptText = (ciphertext: any, jsonCheckDetails: any = {}) => {
    if (ciphertext === null) {
        return null;
    }
    const bytes = CryptoJS.AES.decrypt(
        ciphertext,
        process.env.REACT_APP_PUBLIC_ENCRYPTION_SECRET as string // Assuming env var is defined
    );
    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
    if (Object.entries(jsonCheckDetails).length > 0) {
        plaintext = safePareJson(plaintext, jsonCheckDetails);
    }
    return plaintext;
};

const safePareJson = (plaintext: string, jsonCheckDetails: any) => {
    let jsonParseStatus = false;
    try {
        if (plaintext === "") {
            return jsonCheckDetails.returnType;
        }
        let jsonParse = JSON.parse(plaintext);
        jsonParseStatus = true;
    } catch (err) {
        console.log(
            "Issue in json safePareJson coming from handlePaidCourse()",
            err
        );
    }
    if (jsonParseStatus) {
        return plaintext;
    } else {
        return jsonCheckDetails.returnType;
    }
};
